export const REMOVE_CUSTOMER_TAG = "REMOVE_CUSTOMER_TAG";
export const REMOVE_CUSTOMER_TAG_SUCCESS = "REMOVE_CUSTOMER_TAG_SUCCESS";
export const REMOVE_CUSTOMER_TAG_FAIL = "REMOVE_CUSTOMER_TAG_FAIL";
